import classNames from 'classnames';

import './style.scss';
import { EssentialWorkflowStatus } from 'routes/essential-workspace/state/model';

type IconProps = { className?: string; size?: 'sm' | 'md' | 'lg' };
type MaterialIconProps = { name: string; isOutlined?: boolean } & IconProps;

const MaterialIcon = ({ name, className, isOutlined = false, size = 'md' }: MaterialIconProps) => {
  const isSmSize = size === 'sm';
  const isLgSize = size === 'lg';
  return (
    <i
      className={classNames(
        'icon lh-1',
        { 'icon-outlined': isOutlined, 'icon-sm': isSmSize, 'fs-26': isLgSize },
        className,
      )}
    >
      {name}
    </i>
  );
};

const ReadyIcon = ({ size = 'md' }: IconProps) => {
  const isSmSize = size === 'sm';
  const isLgSize = size === 'lg';
  return <div className={classNames('ready-icon', { 'ready-icon-sm': isSmSize, 'size-22px': isLgSize })} />;
};

const ProgressIcon = ({ size = 'sm' }: IconProps) => {
  const isSmSize = size === 'sm';
  const isLgSize = size === 'lg';
  return (
    <div
      role="status"
      className={classNames('spinner size-20px ', { 'spinner-sm': isSmSize, 'size-22px': isLgSize })}
    />
  );
};

type QuoteIconProps = { status: EssentialWorkflowStatus } & IconProps;

export const QuoteIcon = ({ status, ...props }: QuoteIconProps) => {
  switch (status) {
    case 'creating':
      return <MaterialIcon name="add" isOutlined {...props} />;
    case 'not-ready':
      return <MaterialIcon name="filter_tilt_shift" isOutlined {...props} />;
    case 'ready':
      return <ReadyIcon {...props} />;
    case 'price-in-progress':
      return <ProgressIcon {...props} />;
    case 'priced':
      return <MaterialIcon name="info" isOutlined {...props} />;
    case 'price-expired':
      return <MaterialIcon name="history_toggle_off" isOutlined={false} {...props} />;
    case 'price-rejected':
      return <MaterialIcon name="block" isOutlined={false} {...props} />;
    default:
      return null;
  }
};
